import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const PermissionRoute = ({ children, resource, action, fallback = <div>Access Denied</div> }) => {
  const { hasPermission } = useAuth();
  
  if (!hasPermission(resource, action)) {
    return fallback;
  }
  
  return children;
};

export default PermissionRoute;